var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import API_service from "@iscr/xAppLib/providers/API_service";
import sortBy from "lodash.sortby";
import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";
// TODO Once we can use react query, update this use react query's caching mechanism to avoid multiple API calls
// from multiple mounted LoyaltyTierProviders
export const useLoyaltyTiers = () => useAsync({
    fn: () => __awaiter(void 0, void 0, void 0, function* () {
        const tiers = yield API_service.load_data("loyalty/tiers");
        return sortBy(tiers, "threshold");
    }),
    // Don't fetch when not logged in to avoid error
    immediate: !!app.user.uid,
});
